import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type {
    MatchingFunction,
    TranslatableNameWithType,
} from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type { FilterNameResolver } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterService";
import type UISignalDataDeps from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignalDataDeps";
import filterNamingService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterNamingService";

function createAdNetworksNameFactory(): FilterNameResolver {
    return {
        buildName<F extends SignalFilters & { adNetworkIds: readonly number[] }>(
            filters: F,
            options: UISignalDataDeps["adNetworks"],
        ): Readonly<TranslatableNameWithType> {
            const translationOptions = {
                i18nKeyModifier: "adNetworkIds",
            };
            const numberOfOptions = options.length;

            const matchValueToName: MatchingFunction = (value) => {
                const option = options.find(({ id }) => value === id);

                return option?.name;
            };

            return filterNamingService.buildNameForSelection({
                values: filters.adNetworkIds,
                numberOfOptions,
                matchValueToName,
                translationOptions,
            });
        },
    };
}

export default createAdNetworksNameFactory;
